const drawerTheme = {
    sizes: {
        'discussionDrawer': {
            dialog: {
                maxW: '372px'
            }
        },
        'messageDrawer': {
            dialog: {
                maxW: '372px'
            }
        }
    }
}

export default drawerTheme